import type { Promotion } from '@/app/lib/types'
import type { PromotionApi } from '@/app/lib/api/types-api'

function toPromotion(promotion: PromotionApi): Promotion {
  const price = Number(promotion.price)
  const promotionLabel = promotion.promotionlabel?.trim()

  return {
    id: promotion.id,
    price: promotion.price && !Number.isNaN(price) ? price : null,
    promotionLabel: promotionLabel ? promotionLabel : null,
    isSpecial: promotion.special === 'on',
  }
}

/**
 * FR-004: una promoción es vigente cuando `visible === "on"` Y (`start_at` es
 * nulo o pasado) Y (`end_at` es nulo o futuro). `now` es inyectable para que
 * los tests no dependan de la fecha real del sistema.
 */
export function filterVisiblePromotions(
  promotions: PromotionApi[],
  now: Date = new Date(),
): Promotion[] {
  return promotions
    .filter((promotion) => {
      if (promotion.visible !== 'on') return false

      if (promotion.start_at) {
        const startAt = new Date(promotion.start_at)
        if (!Number.isNaN(startAt.getTime()) && startAt > now) return false
      }

      if (promotion.end_at) {
        const endAt = new Date(promotion.end_at)
        if (!Number.isNaN(endAt.getTime()) && endAt < now) return false
      }

      return true
    })
    .map(toPromotion)
}
